import { useMemo } from "react";
import { isEmpty, isObject, isString } from "@utils";

export const useFilteredPosts = ({ list = [], search = "" }) => {
  return useMemo(() => {
    const searchList = Array.isArray(list) ? list : [];
    const trimmedSearch = isString(search) ? search.trim().toLowerCase() : "";

    if (!trimmedSearch || isEmpty(searchList)) {
      return searchList;
    }

    try {
      return searchList.filter((element) => {
        if (!isObject(element) || isEmpty(element)) return false;

        const post = element.post;

        const targetFields = [
          post?.id,
          element.memberId,
          post?.firstName,
          post?.lastName,
          post?.education?.level,
          post?.professionOther || post?.profession?.name,
          element.phone,
          element.email,
        ];

        return targetFields.some((term) => {
          if (term === null || term === undefined) return false;
          return String(term).toLowerCase().includes(trimmedSearch);
        });
      });
    } catch (error) {
      console.error("Error! Cannot search posts", error);
      return [];
    }
  }, [list, search]);
};